function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSmile2 = function SvgSmile2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "smile-2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 22470",
    d: "M4 0h10a4 4 0 0 1 4 4v3A11 11 0 0 1 7 18H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    transform: "translate(4436 -7281)",
    style: {
      strokeWidth: 2,
      stroke: "currentColor",
      fill: "currentColor"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 33380"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17816",
    d: "M0 0h24v24H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 250",
    style: {
      clipPath: "url(#smile-2_svg__a)"
    },
    transform: "translate(-4433 7284)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 20554",
    style: {
      fill: "currentColor"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 17H4c-1.654 0-3-1.346-3-3V4c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3v3c0 5.514-4.486 10-10 10z",
    style: {
      stroke: "none"
    },
    transform: "translate(4436 -7281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 2c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h3c4.963 0 9-4.037 9-9V4c0-1.103-.897-2-2-2H4m0-2h10a4 4 0 0 1 4 4v3c0 6.075-4.925 11-11 11H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    style: {
      fill: "currentColor",
      stroke: "none"
    },
    transform: "translate(4436 -7281)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21946",
    transform: "translate(4440.392 -7275.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1821",
    cx: 1.35,
    cy: 1.35,
    r: 1.35,
    transform: "translate(6.408)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1822",
    cx: 1.35,
    cy: 1.35,
    r: 1.35,
    transform: "translate(.108)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17817",
    d: "M11.488 15.8a3.6 3.6 0 0 1-3.1-1.8H6.88a4.945 4.945 0 0 0 9.22 0h-1.5a3.586 3.586 0 0 1-3.112 1.8z",
    transform: "translate(-6.88 -8.6)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 27",
    d: "M.688 7.231 0 7.862a8.52 8.52 0 0 1 2.5-5.954A8.5 8.5 0 0 1 8.582 0l-.425.389A6.3 6.3 0 1 1 .688 7.231z",
    transform: "translate(4445.346 -7270.866)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 2,
      opacity: 0.6
    }
  }))));
};

export default SvgSmile2;